// マイプリンター管理 (/pages/printers). RE-SKIN design account/printers.html.
// Logic panel (pulldown 正本 + memo + delete + add form) + card 対応商品 giàu
// (badge 当日出荷/送料無料/在庫あり + %お得 + stock AJAX) đã chuyển sang module chung
// assets/printer-manager.js (window.InkPrinterManager) — dùng chung với hub /pages/mypage.
// Trang này KHÔNG có nút「商品説明を見る」(design printers.html) → detailLink:false.

(function () {
  'use strict';

  function boot() {
    const root = document.querySelector('[data-ink-printers]');
    if (!root || !window.InkPrinterManager) return;
    window.InkPrinterManager.initPanel(root, { detailLink: false });
  }

  let booted = false;
  function startOnce() { if (booted) return; booted = true; boot(); }
  if (window.inkApi) startOnce();
  else { document.addEventListener('ink:api:ready', startOnce, { once: true }); window.addEventListener('load', () => setTimeout(() => { if (!window.inkApi) startOnce(); }, 1000)); }
})();
